import { create } from 'zustand'

interface OrgSelectionState {
  selectedProfileId: string | null
  selectedFamilyUid: string | null
  select: (profileId: string | null, familyUid: string | null) => void
  clear: () => void
}

export const useOrgSelectionStore = create<OrgSelectionState>()((set) => ({
  selectedProfileId: null,
  selectedFamilyUid: null,
  select(profileId, familyUid) {
    set({ selectedProfileId: profileId, selectedFamilyUid: familyUid })
  },
  clear() {
    set({ selectedProfileId: null, selectedFamilyUid: null })
  },
}))
